import {
  StoryData,
  StoryblokImage,
  useStoryblokState,
} from '@cinch-nx/data-storyblok'
import { Head, StoryblokRenderer } from '@cinch-nx/landing-ui-shared'
import { Wrapper } from '@cinch-nx/shared-ui'
import Image from 'next/legacy/image'

import { PartnershipsImageCarousel } from '../components'
import { storyblokComponents } from '../data/storyblok-renderer-map'
import { PartnershipsFeatureProps } from './get-static-props'
import styles from './partnerships.module.css'
import { PartnershipsStoryContent } from './types/partnerships-page'

export function PartnershipsFeature({
  story,
  preview,
  generatedAt,
}: PartnershipsFeatureProps) {
  const typedStory = story as StoryData<PartnershipsStoryContent> & {
    rel: unknown[]
  }

  const { content } = useStoryblokState({
    story: typedStory,
    enableBridge: preview,
  })
  const image = content.Image

  const SEO = content?.SEO?.[0]

  return (
    <>
      <Head
        {...SEO}
        generatedAt={generatedAt}
        fallbackTitle="Partnerships - cinch"
        fallbackDescription="We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
      />
      <article>
        <Wrapper isSlim>
          <StoryblokRenderer
            block={content.Intro}
            components={storyblokComponents}
          />

          <StoryblokRenderer
            block={content.Partners}
            components={storyblokComponents}
          />
        </Wrapper>

        {content?.ImageCarousel?.some(
          (image: StoryblokImage) => image.filename,
        ) ? (
          <Wrapper isFluid>
            <PartnershipsImageCarousel images={content?.ImageCarousel} />
          </Wrapper>
        ) : null}

        <Wrapper isSlim>
          {image?.filename ? (
            <div className={styles.imageWrapper}>
              <Image
                src={image.filename}
                alt={image.alt ?? undefined}
                layout="intrinsic"
                width="801"
                height="481"
                objectFit="contain"
              />
            </div>
          ) : null}
        </Wrapper>
      </article>
    </>
  )
}

export default PartnershipsFeature
